import React, { useCallback, useEffect, useState } from "react";
import { Card, CardBody, Col, Row, Spinner } from "reactstrap";
import { Link, useParams } from "react-router-dom";
import { normalize } from "common/lib/normalize";
import Permissions from "Components/Common/Permissions";
import PSEAAssessmentDetails from "pages/Assessments/PSEAAssessments/PSEAAssessmentDetails";
import { usePseaReader } from "pages/Assessments/PSEAAssessments/usePseaReader";
import { PSEA_CREATE_CHECKS } from "pages/Assessments/PSEAAssessments/usePseaPermissions";

const PSEATab = () => {
  const { id: contractorId } = useParams();
  // Admins read through the main API, agency users through the agency
  // `findOne` route. Neither is scoped to the caller's agency.
  const { fetchByContractor } = usePseaReader();
  const [loading, setLoading] = useState<boolean>(false);
  const [data, setData] = useState<any>(null);

  const fetchData = useCallback(async () => {
    if (!contractorId || !fetchByContractor) return;
    setLoading(true);
    try {
      const response: any = await fetchByContractor(contractorId);
      setData(response?.data ? normalize(response.data) : null);
    } catch (e) {
      setData(null);
    } finally {
      setLoading(false);
    }
  }, [contractorId, fetchByContractor]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  if (loading) {
    return (
      <div className="text-center py-5">
        <Spinner color="primary" />
      </div>
    );
  }

  if (!data) {
    return (
      <Row>
        <Col lg={12}>
          <Card>
            <CardBody className="text-center py-5">
              <div className="avatar-md mx-auto mb-3">
                <div className="avatar-title bg-light text-primary rounded-circle fs-24">
                  <i className="ri-shield-check-line"></i>
                </div>
              </div>
              <h5 className="fs-15">No PSEA assessment found</h5>
              <p className="text-muted mb-3">
                There is no PSEA assessment recorded for this contractor yet.
              </p>
              <Permissions checks={PSEA_CREATE_CHECKS}>
                <Link
                  to={`/assessments/psea-assessments/new?contractor=${contractorId}`}
                  className="btn btn-primary"
                >
                  <i className="ri-add-line align-bottom me-1"></i>
                  Add PSEA Assessment
                </Link>
              </Permissions>
            </CardBody>
          </Card>
        </Col>
      </Row>
    );
  }

  return (
    <Row>
      <Col lg={12}>
        <PSEAAssessmentDetails data={data} embedded />
      </Col>
    </Row>
  );
};

export default PSEATab;
